type ClassNamesProps = string | Record<string, boolean> | [] | number

/**
 * @description Builds a string of class names
 * @param {ClassNamesProps[]} listOfClassNames
 * @returns {string}
 */
const classNames = (listOfClassNames: ClassNamesProps[]): string => {
  const classess: string[] = []

  for (let i = 0; i < listOfClassNames.length; i++) {
    const classItem = listOfClassNames[i]

    const argType = typeof classItem

    if (argType === 'string' || argType === 'number') {
      classess.push(classItem as string)
    } else if (Array.isArray(classItem)) {
      if (classItem.length) {
        const buildClass = classNames.apply(null, classItem)
        if (buildClass) {
          classess.push(buildClass)
        }
      }
    } else if (argType === 'object') {
      if (classItem.toString === Object.prototype.toString) {
        const data = classItem as Record<string, boolean>
        for (let key in data) {
          if (Object.hasOwn(data, key) && data[key]) {
            classess.push(key)
          }
        }
      }
    } else {
      classess.push(classItem.toString())
    }
  }

  return classess.join(' ')
}

export default classNames
